import { useTranslation } from 'react-i18next'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

// Looking at one product photo, full-bleed.
//
// The old shape was Popup's `image` mode: a transparent box holding an <img>
// capped at 80vw/75vh. Two problems. A backdrop tap was the only way out and
// nothing said so, and the fixed caps ignored the shape of the photo -- product
// images here run portrait as often as landscape.
export default function Lightbox(props) {
    const { open, onClose, src, alt } = props
    const { t } = useTranslation()

    if (!src) return null

    return (
        <Modal open={Boolean(open)} onClose={onClose}>
            <Box
                onClick={onClose}
                sx={{
                    position: 'fixed',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // Room for the close control, and for the photo to breathe.
                    padding: 2,
                    outline: 'none'
                }}
            >
                <IconButton
                    aria-label={t('common.close')}
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: 'calc(8px + env(safe-area-inset-top))',
                        right: 8,
                        width: 44,
                        height: 44,
                        color: '#fff',
                        bgcolor: 'rgba(0, 0, 0, 0.45)',
                        '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.65)' }
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <img
                    src={src}
                    alt={alt}
                    // Fit whichever way the photo runs, rather than assuming.
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                        borderRadius: '12px'
                    }}
                    onClick={event => event.stopPropagation()}
                />
            </Box>
        </Modal>
    )
}
